import Lottie from "lottie-react";
import groovyWalkAnimation from "../../../../assets/images/Store scan-new.json";
import BOtagBlink from "../../../../assets/images/BOtag Blink.json";
import { useEffect, useState } from "react";

const style = {
    height: "97px",
    display: "flex",
    justifyContent: "center",
    width: "97px",
    alignItems: "center"
};
const styleSmiley = {
    height: "87px",
    display: "flex",
    justifyContent: "center",
    width: "87px",
    alignItems: "center"
};
const BOTagBodyLoading = ({
    loadingStatus,
    headerMessage,
    checkAnotherLoactionBtn,
    showSizeSelection,
    showColorSelection,
    showQuantitySelection
}) => {
    const [textKey, setTextKey] = useState(0);

    // Change the text key when loadingStatus changes
    useEffect(() => {
        setTextKey(prevKey => prevKey + 1);
    }, [loadingStatus]);
    return (
        <>
            {headerMessage || checkAnotherLoactionBtn || showSizeSelection || showColorSelection || showQuantitySelection ? (
                <div
                    style={{
                        width: "232px",
                        height: "48px"
                    }}>
                    &nbsp;
                </div>
            ) : (
                ""
            )}
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "232px",
                    justifyContent: "space-around",
                    alignItems: "center",
                    height: "174px",
                    gap: "8px"
                }}>
                {loadingStatus === "fetching" || loadingStatus === "almostdone" ? (
                    <Lottie animationData={groovyWalkAnimation} style={style} />
                ) : (
                    <Lottie animationData={BOtagBlink} style={styleSmiley} />
                )}
                <div
                    key={textKey}
                    style={{
                        display: "flex",
                        justifyContent: "center", // Center text horizontally
                        alignItems: "center",
                        fontSize: "12px",
                        fontWeight: 600,
                        width: "100%"
                    }}>
                    {loadingStatus === "fetching"
                        ? "Looking for stores..."
                        : loadingStatus === "almostdone"
                        ? "Almost done..."
                        : "Found one!"}
                </div>

                <style>
                    {`
                    @keyframes scroll-left {
                        0% {
                            transform: translateX(100%); 
                        }
                        100% {
                            transform: translateX(0);
                        }
                    }
                `}
                </style>
            </div>
        </>
    );
};

export default BOTagBodyLoading;
